var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 21,
    viewBox: "0 0 88 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8901 13.3026C20.8901 12.2132 21.1145 11.2484 21.5631 10.4084C22.025 9.56829 22.6452 8.91855 23.4237 8.45913C24.2154 7.9866 25.093 7.75033 26.0562 7.75033C26.7688 7.75033 27.4682 7.90784 28.1544 8.22287C28.8537 8.52477 29.4079 8.93167 29.817 9.44359V4.2063H32.0933V18.7762H29.817V17.142C29.4475 17.6671 28.9329 18.1002 28.2731 18.4415C27.6265 18.7828 26.881 18.9534 26.0364 18.9534C25.0864 18.9534 24.2154 18.7171 23.4237 18.2446C22.6452 17.7589 22.025 17.0895 21.5631 16.2363C21.1145 15.37 20.8901 14.3921 20.8901 13.3026ZM29.817 13.342C29.817 12.5938 29.6587 11.9441 29.342 11.3928C29.0385 10.8415 28.636 10.4215 28.1346 10.1327C27.6331 9.84393 27.0921 9.69955 26.5115 9.69955C25.9309 9.69955 25.3899 9.84393 24.8884 10.1327C24.387 10.4084 23.9779 10.8218 23.6612 11.3731C23.3577 11.9113 23.206 12.5545 23.206 13.3026C23.206 14.0508 23.3577 14.7071 23.6612 15.2716C23.9779 15.836 24.387 16.2691 24.8884 16.571C25.4031 16.8598 25.9441 17.0042 26.5115 17.0042C27.0921 17.0042 27.6331 16.8598 28.1346 16.571C28.636 16.2823 29.0385 15.8622 29.342 15.3109C29.6587 14.7465 29.817 14.0902 29.817 13.342Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0157 18.9534C38.158 18.9534 37.3861 18.8025 36.6999 18.5006C36.0269 18.1855 35.4925 17.7655 35.0966 17.2405C34.7007 16.7023 34.4896 16.1051 34.4632 15.4488H36.7988C36.8384 15.9082 37.0562 16.2954 37.452 16.6104C37.8611 16.9123 38.3691 17.0633 38.9761 17.0633C39.6095 17.0633 40.0978 16.9451 40.4409 16.7089C40.7971 16.4595 40.9753 16.1444 40.9753 15.7638C40.9753 15.3569 40.7773 15.055 40.3815 14.8581C39.9988 14.6612 39.3852 14.4446 38.5407 14.2083C37.7225 13.9852 37.0562 13.7686 36.5415 13.5586C36.0269 13.3486 35.5783 13.027 35.1956 12.5938C34.8261 12.1607 34.6414 11.5897 34.6414 10.8809C34.6414 10.3033 34.8129 9.7783 35.156 9.30576C35.4991 8.8201 35.9873 8.43945 36.6207 8.1638C37.2673 7.88815 38.0063 7.75033 38.8376 7.75033C40.078 7.75033 41.0742 8.06535 41.8264 8.6954C42.5917 9.31233 43.0008 10.159 43.0536 11.2353H40.7971C40.7575 10.7496 40.5596 10.3624 40.2033 10.0736C39.847 9.78487 39.3654 9.64048 38.7584 9.64048C38.1646 9.64048 37.7094 9.75205 37.3927 9.97519C37.076 10.1983 36.9176 10.4937 36.9176 10.8612C36.9176 11.15 37.0232 11.3928 37.2343 11.5897C37.4454 11.7866 37.7028 11.9441 38.0063 12.0622C38.3098 12.1672 38.7584 12.3051 39.3522 12.4757C40.144 12.6857 40.7905 12.9023 41.292 13.1254C41.8066 13.3355 42.2487 13.6505 42.6181 14.0705C42.9876 14.4905 43.179 15.0484 43.1922 15.7441C43.1922 16.361 43.0206 16.9123 42.6775 17.398C42.3344 17.8836 41.8462 18.2643 41.2128 18.5399C40.5926 18.8156 39.8602 18.9534 39.0157 18.9534Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2628 9.75861V15.7638C48.2628 16.1707 48.3552 16.466 48.5399 16.6498C48.7379 16.8204 49.0678 16.9057 49.5296 16.9057H50.9152V18.7762H49.1338C48.1177 18.7762 47.3391 18.5399 46.7981 18.0674C46.2571 17.5949 45.9866 16.827 45.9866 15.7638V9.75861H44.7V7.92753H45.9866V5.23013H48.2628V7.92753H50.9152V9.75861H48.2628Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2427 13.3026C52.2427 12.2132 52.4671 11.2484 52.9157 10.4084C53.3776 9.56829 53.9977 8.91855 54.7763 8.45913C55.568 7.9866 56.4389 7.75033 57.389 7.75033C58.2468 7.75033 58.9923 7.92097 59.6257 8.26224C60.2723 8.5904 60.7869 9.00387 61.1696 9.50265V7.92753H63.4458V18.7762H61.1696V17.1617C60.7869 17.6736 60.2657 18.1002 59.6059 18.4415C58.9461 18.7828 58.194 18.9534 57.3494 18.9534C56.4126 18.9534 55.5548 18.7171 54.7763 18.2446C53.9977 17.7589 53.3776 17.0895 52.9157 16.2363C52.4671 15.37 52.2427 14.3921 52.2427 13.3026ZM61.1696 13.342C61.1696 12.5938 61.0112 11.9441 60.6945 11.3928C60.391 10.8415 59.9886 10.4215 59.4871 10.1327C58.9857 9.84393 58.4447 9.69955 57.8641 9.69955C57.2835 9.69955 56.7424 9.84393 56.241 10.1327C55.7396 10.4084 55.3305 10.8218 55.0138 11.3731C54.7103 11.9113 54.5586 12.5545 54.5586 13.3026C54.5586 14.0508 54.7103 14.7071 55.0138 15.2716C55.3305 15.836 55.7396 16.2691 56.241 16.571C56.7556 16.8598 57.2967 17.0042 57.8641 17.0042C58.4447 17.0042 58.9857 16.8598 59.4871 16.571C59.9886 16.2823 60.391 15.8622 60.6945 15.3109C61.0112 14.7465 61.1696 14.0902 61.1696 13.342Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6575 13.342C65.6575 12.2263 65.8818 11.2484 66.3304 10.4084C66.7923 9.55516 67.4257 8.89886 68.2306 8.43945C69.0355 7.98004 69.9592 7.75033 71.0017 7.75033C72.3213 7.75033 73.4099 8.06535 74.2676 8.6954C75.1385 9.31233 75.7258 10.1983 76.0293 11.3534H73.5947C73.3967 10.8153 73.08 10.3952 72.6446 10.0933C72.2091 9.79143 71.6615 9.64048 71.0017 9.64048C70.078 9.64048 69.339 9.96863 68.7848 10.6249C68.2438 11.2681 67.9733 12.1738 67.9733 13.342C67.9733 14.5102 68.2438 15.4225 68.7848 16.0788C69.339 16.7351 70.078 17.0633 71.0017 17.0633C72.3081 17.0633 73.1724 16.4923 73.5947 15.3503H76.0293C75.7126 16.4529 75.1187 17.3323 74.2478 17.9886C73.3769 18.6318 72.2949 18.9534 71.0017 18.9534C69.9592 18.9534 69.0355 18.7237 68.2306 18.2643C67.4257 17.7917 66.7923 17.1354 66.3304 16.2954C65.8818 15.4422 65.6575 14.4577 65.6575 13.342Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.593 13.3617L87.6205 18.7762H84.5723L80.5344 14.1099V18.7762H78.278V4.2063H80.5344V12.6726L84.4931 7.92753H87.6205L82.593 13.3617Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20035 8.6862C2.30151 9.02799 0.919922 10.6805 0.919922 12.6098L0.919922 20.0867H3.83327L3.83327 11.96C3.83327 10.6567 4.06327 9.58334 4.75327 8.58667L4.20035 8.6862Z",
    fill: "url(#paint0_linear_8927_5693)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8861 11.4005C17.7849 11.0587 19.1665 9.40621 19.1665 7.47685L19.1665 -3.24249e-05H16.2532L16.2532 8.12666C16.2532 9.42999 16.0232 10.5033 15.3332 11.5L15.8861 11.4005Z",
    fill: "url(#paint1_linear_8927_5693)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0932 2.45334C18.0932 2.70736 17.8873 2.91328 17.6333 2.91328C17.3793 2.91328 17.1733 2.70736 17.1733 2.45334C17.1733 2.19933 17.3793 1.99341 17.6333 1.99341C17.8873 1.99341 18.0932 2.19933 18.0932 2.45334Z",
    fill: "#CF07D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75972 17.6333C2.75972 17.8873 2.5538 18.0932 2.29978 18.0932C2.04576 18.0932 1.83984 17.8873 1.83984 17.6333C1.83984 17.3793 2.04576 17.1733 2.29978 17.1733C2.5538 17.1733 2.75972 17.3793 2.75972 17.6333Z",
    fill: "#CF07D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9359 2.9297C13.7761 2.7323 13.8065 2.44268 14.0039 2.28282C14.2013 2.12296 14.491 2.1534 14.6508 2.35081L15.9565 3.96325C16.0098 4.02905 15.9997 4.12559 15.9339 4.17888L15.4573 4.56481C15.3915 4.61809 15.2949 4.60795 15.2417 4.54214L13.9359 2.9297Z",
    fill: "url(#paint2_linear_8927_5693)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4349 4.78052C15.3816 4.71472 15.3917 4.61818 15.4575 4.56489L15.9341 4.17897C15.9999 4.12568 16.0965 4.13583 16.1497 4.20163L17.3749 5.71459C17.5348 5.912 17.5043 6.20162 17.3069 6.36148C17.1095 6.52133 16.8199 6.49089 16.66 6.29349L15.4349 4.78052Z",
    fill: "url(#paint3_linear_8927_5693)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58651 4.94307C8.58651 3.01372 9.96809 1.36124 11.8669 1.01945L12.4199 0.919922C11.7299 1.91659 11.4998 2.98993 11.4998 4.29327V11.3466H8.58651V4.94307ZM11.4998 15.1435C11.4998 17.0728 10.1183 18.7253 8.21942 19.0671L7.6665 19.1666C8.35651 18.17 8.58651 17.0966 8.58651 15.7933V11.3466H11.4998V15.1435Z",
    fill: "url(#paint4_linear_8927_5693)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43593 14.4297C2.27607 14.2323 2.30651 13.9427 2.50392 13.7828C2.70133 13.623 2.99095 13.6534 3.15081 13.8508L4.45654 15.4633C4.50982 15.5291 4.49968 15.6256 4.43387 15.6789L3.95729 16.0648C3.89149 16.1181 3.79495 16.1079 3.74166 16.0421L2.43593 14.4297Z",
    fill: "url(#paint5_linear_8927_5693)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93486 16.2805C3.88158 16.2147 3.89172 16.1182 3.95752 16.0649L4.43411 15.679C4.49991 15.6257 4.59645 15.6358 4.64974 15.7016L5.87491 17.2146C6.03477 17.412 6.00433 17.7016 5.80692 17.8615C5.60951 18.0213 5.31989 17.9909 5.16004 17.7935L3.93486 16.2805Z",
    fill: "url(#paint6_linear_8927_5693)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35634 11.0564C3.19648 10.859 3.22692 10.5694 3.42433 10.4095C3.62174 10.2497 3.91136 10.2801 4.07122 10.4775L6.51342 13.4934C6.5667 13.5592 6.55656 13.6557 6.49076 13.709L6.01417 14.0949C5.94837 14.1482 5.85183 14.1381 5.79854 14.0723L3.35634 11.0564Z",
    fill: "url(#paint7_linear_8927_5693)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99199 14.3113C5.9387 14.2455 5.94885 14.1489 6.01465 14.0957L6.49124 13.7097C6.55704 13.6564 6.65358 13.6666 6.70686 13.7324L9.01439 16.582C9.17425 16.7794 9.14381 17.069 8.9464 17.2288C8.749 17.3887 8.45938 17.3583 8.29952 17.1608L5.99199 14.3113Z",
    fill: "url(#paint8_linear_8927_5693)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4005 15.8863C11.0587 17.7852 9.40621 19.1667 7.47685 19.1667H-3.14713e-05V16.2534H8.12666C9.42999 16.2534 10.5033 16.0234 11.5 15.3334L11.4005 15.8863Z",
    fill: "url(#paint9_linear_8927_5693)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0228 3.54298C10.863 3.34558 10.8934 3.05596 11.0908 2.8961C11.2882 2.73624 11.5779 2.76668 11.7377 2.96409L14.1799 5.97996C14.2332 6.04576 14.2231 6.1423 14.1573 6.19559L13.6807 6.58152C13.6149 6.6348 13.5183 6.62466 13.465 6.55885L11.0228 3.54298Z",
    fill: "url(#paint10_linear_8927_5693)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6585 6.79786C13.6052 6.73205 13.6154 6.63551 13.6812 6.58223L14.1577 6.1963C14.2235 6.14301 14.3201 6.15316 14.3734 6.21896L16.6809 9.06852C16.8408 9.26593 16.8103 9.55555 16.6129 9.71541C16.4155 9.87526 16.1259 9.84482 15.966 9.64742L13.6585 6.79786Z",
    fill: "url(#paint11_linear_8927_5693)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26943 10.4431C6.10957 10.2457 6.14001 9.9561 6.33742 9.79625C6.53483 9.63639 6.82445 9.66683 6.9843 9.86424L8.29003 11.4767C8.34332 11.5425 8.33317 11.639 8.26737 11.6923L7.79079 12.0782C7.72498 12.1315 7.62844 12.1214 7.57516 12.0556L6.26943 10.4431Z",
    fill: "url(#paint12_linear_8927_5693)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76836 12.294C7.71507 12.2281 7.72522 12.1316 7.79102 12.0783L8.2676 11.6924C8.33341 11.6391 8.42995 11.6493 8.48323 11.7151L9.70841 13.228C9.86826 13.4254 9.83782 13.715 9.64042 13.8749C9.44301 14.0348 9.15339 14.0043 8.99353 13.8069L7.76836 12.294Z",
    fill: "url(#paint13_linear_8927_5693)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68644 4.20035C9.02823 2.30151 10.6807 0.919922 12.6101 0.919922H20.0869V3.83326H11.9603C10.6569 3.83326 9.58358 4.06326 8.58691 4.75327L8.68644 4.20035Z",
    fill: "url(#paint14_linear_8927_5693)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9496 6.91628C9.78975 6.71887 9.82019 6.42925 10.0176 6.26939C10.215 6.10953 10.5046 6.13997 10.6645 6.33738L11.9702 7.94982C12.0235 8.01562 12.0133 8.11216 11.9475 8.16545L11.471 8.55138C11.4052 8.60467 11.3086 8.59452 11.2553 8.52872L9.9496 6.91628Z",
    fill: "url(#paint15_linear_8927_5693)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4485 8.76709C11.3952 8.70129 11.4054 8.60475 11.4712 8.55147L11.9478 8.16554C12.0136 8.11225 12.1101 8.1224 12.1634 8.1882L13.3886 9.70116C13.5484 9.89857 13.518 10.1882 13.3206 10.348C13.1232 10.5079 12.8336 10.4775 12.6737 10.2801L11.4485 8.76709Z",
    fill: "url(#paint16_linear_8927_5693)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4267 10.1198C10.4267 10.3739 10.2208 10.5798 9.96677 10.5798C9.71276 10.5798 9.50684 10.3739 9.50684 10.1198C9.50684 9.86583 9.71276 9.65991 9.96677 9.65991C10.2208 9.65991 10.4267 9.86583 10.4267 10.1198Z",
    fill: "#22BADB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1434 11.4999C17.0727 11.4999 18.7252 10.1183 19.067 8.2195L19.1665 7.66658C18.1698 8.35658 17.0965 8.58658 15.7932 8.58658L8.73981 8.58658V11.4999L15.1434 11.4999ZM4.94293 8.58658C3.01357 8.58658 1.36109 9.96817 1.0193 11.867L0.919777 12.4199C1.91645 11.7299 2.98978 11.4999 4.29312 11.4999L8.7398 11.4999V8.58658L4.94293 8.58658Z",
    fill: "url(#paint17_linear_8927_5693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8927_5693",
    x1: 1.60992,
    y1: 20.93,
    x2: 1.68659,
    y2: 8.58667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0428911,
    stopColor: "#B019E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195594,
    stopColor: "#9C2B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430184,
    stopColor: "#DC46D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627832,
    stopColor: "#BD23CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8927_5693",
    x1: 17.7865,
    y1: 10.7333,
    x2: 17.7098,
    y2: -0.766704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F139D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303464,
    stopColor: "#D143B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501827,
    stopColor: "#8226C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF15DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8927_5693",
    x1: 13.8372,
    y1: 2.7703,
    x2: 15.6492,
    y2: 4.44275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5991D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11519E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8927_5693",
    x1: 15.8697,
    y1: 5.36633,
    x2: 17.1729,
    y2: 5.13636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C050E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8022A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8927_5693",
    x1: 10.0432,
    y1: 0.919922,
    x2: 10.0432,
    y2: 19.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CBACB",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154499,
    stopColor: "#0886BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334093,
    stopColor: "#0CBCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60681,
    stopColor: "#14D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786865,
    stopColor: "#0CA0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0665BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8927_5693",
    x1: 4.59948,
    y1: 15.6397,
    x2: 2.10951,
    y2: 14.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C050E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8022A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8927_5693",
    x1: 3.83314,
    y1: 16.5597,
    x2: 6.13282,
    y2: 17.3263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F77FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22CA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8927_5693",
    x1: 6.82296,
    y1: 13.2631,
    x2: 3.68007,
    y2: 11.8832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5991D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11519E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8927_5693",
    x1: 5.59689,
    y1: 14.1067,
    x2: 9.35304,
    y2: 16.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77D3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A69C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8927_5693",
    x1: 11.5,
    y1: 18.4767,
    x2: -0.306701,
    y2: 18.4767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055BAB",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196658,
    stopColor: "#0794C0",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371414,
    stopColor: "#05B4D0",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536277,
    stopColor: "#30C2D8",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806654,
    stopColor: "#1FBFD0",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CC6D9",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8927_5693",
    x1: 14.4895,
    y1: 5.74963,
    x2: 11.3466,
    y2: 4.36982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5991D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11519E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8927_5693",
    x1: 13.2634,
    y1: 6.5933,
    x2: 17.0195,
    y2: 9.42956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77D3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A69C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8927_5693",
    x1: 8.63435,
    y1: 11.2893,
    x2: 6.80081,
    y2: 10.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5991D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11519E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8927_5693",
    x1: 7.66663,
    y1: 12.5731,
    x2: 9.96632,
    y2: 13.3397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD7EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D57B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8927_5693",
    x1: 8.58691,
    y1: 2.75993,
    x2: 21.1603,
    y2: 2.75993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0397C6",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304027,
    stopColor: "#31D0E1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526955,
    stopColor: "#43E1ED",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783942,
    stopColor: "#1DB0C8",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098A9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8927_5693",
    x1: 12.1132,
    y1: 8.12632,
    x2: 9.62318,
    y2: 7.23284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C050E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8022A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8927_5693",
    x1: 11.3468,
    y1: 9.04628,
    x2: 13.6465,
    y2: 9.81283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22CA0",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8927_5693",
    x1: 19.1665,
    y1: 10.0432,
    x2: 0.919777,
    y2: 10.0432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A724A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.240046,
    stopColor: "#E344E3",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651048,
    stopColor: "#FE7CE6",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756859,
    stopColor: "#EE6FEE",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE0595",
    stopOpacity: 0.9
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.f602feeb138844eda97c8cb641461448.svg";